function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/** @jsxRuntime classic */

/** @jsx jsx */
import { jsx } from '@emotion/core';
import { useState, useEffect, useImperativeHandle, memo, useCallback } from 'react';
import classNames from 'classnames';
import style from './cardSelector.style';
import { mediaQuery } from '../../../utils';
/**
 * This component represent a Card selector.
 * @param {Array} data Array with the button selector options.
 * @param {function} onChange Function triggered every time that the selected card change.
 * @param {*} value Actual value of the card selector.
 * @param {object} containerRef Ref to the card selector.
 * @param {Error} error Error on card selector.
 * @param {boolean} touched Value used to determine if the card selector is touched or not, usually formik.touched is used here.
 * @param {boolean} onlyView Boolean value used to determine if the card selector is enable or disabled.
 * @param {JSON} addStyle Custom style h4 tag in card.
 * @param {function} t Translate.
 * @param {*} props All other supported props.
 */

const CardSelector = /*#__PURE__*/memo(({
  data,
  onChange,
  value = '',
  containerRef = null,
  error,
  touched,
  className,
  onlyView = false,
  addStyle,
  t,
  ...props
}) => {
  const [state, setState] = useState({
    current: ''
  });
  const changeCurrent = useCallback(current => {
    setState(values => ({ ...values,
      current
    }));

    if (onChange) {
      onChange(current);
    }
  }, [onChange]);
  useEffect(() => {
    setState(values => ({ ...values,
      current: value
    }));
  }, [value]);
  useImperativeHandle(containerRef, () => ({
    clean() {
      setState(values => ({ ...values,
        current: ''
      }));
      onChange('');
    }

  }));
  return jsx("div", {
    css: style
  }, data.map(item => jsx("div", {
    className: "card",
    key: item === null || item === void 0 ? void 0 : item.procedureCode
  }, !onlyView && jsx("div", {
    className: "checkbox-container"
  }, jsx("div", null, jsx("input", _extends({
    id: item.procedureCode,
    key: `${item.procedureCode}_${item.holderRecordNumber}`,
    type: "radio",
    value: item.procedureCode,
    checked: state.current.procedureCode === item.procedureCode,
    className: classNames({
      checked: state.current.procedureCode === item.procedureCode,
      [className]: true
    }),
    onChange: () => changeCurrent(item)
  }, props)), jsx("label", {
    htmlFor: item.procedureCode
  }))), jsx("div", {
    className: "card-text",
    css: {
      [mediaQuery[0]]: {
        padding: onlyView ? '0 22px' : '',
        flexBasis: onlyView ? '100%' : '80%'
      }
    }
  }, jsx("h4", {
    style: { ...addStyle
    }
  }, `${item.procedureCode} - ${item.procedureName}`), jsx("p", null, `${t('Nombre del titular')}: ${item.holderName}`), jsx("p", null, `${t('Número de identificación')}: ${item.holderIdentification}`), jsx("p", null, `${t('Número de expediente')}: Nº${item.holderRecordNumber}`)))));
});
export default CardSelector;